import { Title } from "../common/Title";

export const SectionTitle = () => {
  return <Title text="NE KONUŞUYORLAR?" />;
};
